const isWlsBookingNotFoundError = error =>
  Boolean(error && error.response && error.response.status === 404);

export default isWlsBookingNotFoundError;
